var Animate = {
	top: 0,
	show: 0
}
var animations = [];
var isPage = "";
var common = {
	init: ()=>{
		dialog.checkCookie();
		let $body = $("body");
		let resizeFlag,
			resizeTimer = null;

		common.start();
		common.nav();

		$(document).on("scroll touchmove", function(){
			common.scrl();
		});

		/* window resize
		----------------------------- */
		window.onresize = function(){
			if(resizeTimer > 0){
				clearTimeout(resizeTimer);
			}
			resizeTimer = setTimeout(function(){
				if(!$body.hasClass("resize")){
					$body.addClass("resize");
				}
				common.resize();
				resizeTimer = null;
			}, 200);
		}
	},
	start: function(){
		common.resize();
		page.init();
	},
	nav: function(){
		let $btnLang = $("#glbnav .btn_lang");
		let $btnLang02 = $(".subnav .btn_lang");
		$("#glbnav .btn_lang").off().on("click", function(){
			if(!$btnLang.hasClass("active")){
				$btnLang.addClass("active");
			}else{
				$btnLang.removeClass("active");
			}
			$("#glbnav .lang_list").animate({
				height: "toggle", opacity: "toggle"
			},300);
		});
		$(".subnav .btn_lang").off().on("click", function(){
			if(!$btnLang02.hasClass("active")){
				$btnLang02.addClass("active");
			}else{
				$btnLang02.removeClass("active");
			}
			$(".subnav .lang_list").animate({
				height: "toggle", opacity: "toggle"
			},300);
		});

		$("#btn_menu").off().on("click", function(){
			if(!$html.classList.contains("menu")){
				$html.classList.add("menu");
				setTimeout(function(){
					$html.classList.add("show_menu");
				}, 100);
			}else{
				closeMenu();
			}
		});
		$("#btn_close").off().on("click", function(){
			closeMenu();
		});

		//FILTER
		$(".btn_filter a").off().on("click", function(){
			if(!$html.classList.contains("show_filter")){
				$html.classList.add("show_filter");
			}else{
				$html.classList.remove("show_filter");
			}
		});
		$("#btn_close_filter").off().on("click", function(){
			if($html.classList.contains("show_filter")){
				$html.classList.remove("show_filter");
			}
		});
		
		//ナビではないところクリックで閉じる
		$("#bg").off().on("click", function(){
			if($html.classList.contains("show_filter")){
				$html.classList.remove("show_filter");
			}
			if($html.classList.contains("menu")){
				closeMenu();
			}
		});
		$("h1 a").off().on("click", function(e){
			e.preventDefault();
			if(isLang === "en"){
				if($html.classList.contains("product")){
					page.changeURL("/en/");
					var ttl = $("h1 a").text();
					document.title = ttl;
				}else{
					location.href = "/en/";
				}
			}else{
				if($html.classList.contains("product")){
					page.changeURL("/");
					var ttl = $("h1 a").text();
					document.title = ttl;
				}else{
					location.href = "/";
				}
			}
			
			/*
			else if($html.classList.contains("dictionary")){
				page.changeURL("/dictionary/");
			}else if($html.classList.contains("news")){
				page.changeURL("/news/");
			}*/
		});
		var $head = document.getElementsByTagName('head')[0].children;
		var links = [];
		for(var i = 0; i < $head.length; i++){
			var l = $head[i];
			if($(l).attr("rel") === "alternate"){
				links.push(l);
			}
		}
		common.getLangURL(links);
		function closeMenu(){
			if($html.classList.contains("menu")){
				$html.classList.remove("show_menu");
				setTimeout(function(){
					$html.classList.remove("menu");
				},600);
			}
		}
	},
	resize: ()=>{
		var winW = window.innerWidth;
		var winH = window.innerHeight;
		var $body = $("body");
		if (window.matchMedia('all and (min-width : 864px)').matches) {
			isSmallScreen = false;
		} else if(window.matchMedia('all and (min-width : 0px)').matches) {
			isSmallScreen = true;
		}
		if( page.folder === "" ){
			//smoothScroll.resize();
		}
		setTimeout(function(){
			if($body.hasClass("resize")){
				$body.removeClass("resize");
			}
		},300);
	},
	scrollToPosition: (posY, duration) =>{
		var $page 	= $("html,body"),
			ease 	= "easeInOutCubic";
		$page.animate({
			scrollTop : posY + "px"
		},{
			"duration" 	: duration,
			"easing" 	: ease,
			"complete"	: function(){
				
			}
		});
	},
	scrl: () =>{
		var topD 	= $(document).scrollTop(),
			btmD 	= topD + $(window).height(),
			dH 		= $(document).height(),
			halfH 	= window.innerHeight/2,
			changeH = 100;
		if(isSmallScreen){
			changeH = 30;
		}else{
			changeH = 100;
		}
		if(!$html.classList.contains("product")){
			if(topD >= changeH){
				if(!$html.classList.contains("small_header")){
					$html.classList.add("small_header");
				}
			}else{
				if($html.classList.contains("small_header")){
					$html.classList.remove("small_header");
				}
			}
		}
		
		//console.log(page.folder);
		//product
		if(page.folder === "" || page.folder == "product"){
			if(btmD >= dH - halfH){
				if(!$html.classList.contains("product")){
					if(!$("body").hasClass("loading_content")){
						product.loadNext();
					}
				}
			}
		}else if(page.folder === "news"){
			if(btmD >= dH - halfH){
				if(!$("body").hasClass("loading_content")){
					news.loadNext();
				}
			}
		}else if(page.folder === "dictionary"){
			if(btmD >= dH - halfH){
				if(!$("body").hasClass("loading_content")){
					dic.loadNext();
				}
			}
		}
		if($html.classList.contains("active_product")){
			let alen = animations.length;

			for(var a = 0; a < alen; a++){
				if(a === alen - 1){
					if(btmD >= animations[a].show){
						activeAnimation(a)
					}
				}else{
					if(btmD >= animations[a].show){
						activeAnimation(a)
					}
				}
			}

			function activeAnimation(a){
				var $block = $(".a").eq(a);
				if(!$block.hasClass("animate")){
					$block.addClass("animate");
					if( $block.hasClass("block_chart") ){
					//	document.getElementById("showChart").beginElement();
					}
					setTimeout(function(){
						$block.addClass("animated");
					},1000);
				}
			}
		}
	},
	mouseCursor: function(){
		if(page.folder === "product"){
			$(document).off("mousemove").on("mousemove", function(e){
				mouse[0] = e.clientX;
				mouse[1] = e.clientY;
				//let _t 	= e.clientY - $("#recommend_product").offset().top + 118;
				let _t = mouse[1] - 50;
				if(_t < 0){
					_t = 0;
				}
				pointer[0][1] = mouse[0] -50;
				pointer[1][1] = _t;
			});
		}
	},
	getLangURL: function(links){
		var count = 0;
		for(var i = 0; i < links.length; i++){
			var l = links[i];
			if(isLang === "ja"){
				if(l.hreflang === "en"){
					var link = l.href;
					$(".lang_list li.lang_en a").attr("href", link);
					count++;
				}
			}else if(isLang === "en"){
				if(l.hreflang === "ja"){
					var link = l.href;
					$(".lang_list li.lang_ja a").attr("href", link);
					count++;
				}
			}
		}
		let $btnLang = $(".btn_lang");
		if(count === 0){
			if(!$btnLang.hasClass("disable")){
				$(".btn_lang").addClass("disable");
			}
		}else{
			if($btnLang.hasClass("disable")){
				$(".btn_lang").removeClass("disable");
			}
		}
	},
	startLoading: function(){
		$("header #loading p").removeClass("loadend");
		$("body").addClass("loading_content");
	},
	endLoading: function(){
		$("header #loading p").addClass("loadend");
		$("header #loading p").css("width", "0%");
	}
}
//2021.07.14 added
let dialog = {
	checkCookie: function(){
		let dialogID = $("#txt_dialog").attr("data-id");
		let visitedID = Cookies.get("the_visitedID");
		if( !visitedID ){
			
		}else{
			//内容が変わっていたら
			if( dialogID != visitedID ){
				dialog.setCookie(dialogID);
			}else{
				$("#block_dialog").remove();
			}
		}
		$("a#btn_close_dialog").off().on("click", function(){
			dialog.closeDialog(dialogID);
		});
	},
	setCookie: function(dialogID){
		Cookies.set('the_visitedID', dialogID, {
			//secure: true,
			expires: 7,
			domain: location.domainname
		});
	},
	closeDialog: function(dialogID){
		dialog.setCookie(dialogID);
		$("#block_dialog").addClass("disable");
		setTimeout(function(){
			$("#block_dialog").remove();
		}, 600);
	}
}
document.addEventListener('DOMContentLoaded', function () {
	isPage = $("body").attr("id");
	common.init();
});